import { map, pipe } from "rxjs"

import { LeadSummary } from "src/app/core/models/lead/lead-summary.model"
import { LeadSummaryDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead.dto"
import { businessSectorDtoToBusinessSector } from "../common-model-dto/business-sector-dto.mapping"
import { emailDtoToContact, phoneDtoToContact } from "../common-model-dto/contact-dto.mapping"
import { provinceDtoToProvince } from "../common-model-dto/province-dto.mapping"
import { userDtoToUserProfile } from "../user-model-dto/user-profile-dto.mapping"
import { leadAssignationDtoToLeadAssignation } from "./lead-assingation-dto.mapping"
import { fiscalIdDtoToFiscalId } from "./lead-fiscal-id-dto.mapping"
import { LeadHeadDtoToLeadHead } from "./lead-head-dto.mapping"
import { leadAssignationOfferDtoToLeadAssignationOffer } from "./lead-offer-dto.mapping"

export const mapLeadSummaryDtoToLeadSummary = pipe(
    map((source: LeadSummaryDto) => leadSummaryDtoToLeadSummary(source))
)

export function leadSummaryDtoToLeadSummary(source: LeadSummaryDto): LeadSummary {
    return {
        ...LeadHeadDtoToLeadHead(source),
        injectorDescriptor: source.leadInjectorDescriptor?.description ?? undefined,
        province: provinceDtoToProvince(source.provincia),
        businessSector: businessSectorDtoToBusinessSector(source.businessSector),
        contacts: source.phoneNumbers?.map(c => phoneDtoToContact(c)).concat(source.emails.map(e => emailDtoToContact(e))),
        fiscalIds: source.fiscalIds?.map(f => fiscalIdDtoToFiscalId(f)),
        assignation: leadAssignationDtoToLeadAssignation(source.assignation),
        offer: leadAssignationOfferDtoToLeadAssignationOffer(source.assignationOffer),
        owner: source.owner ? userDtoToUserProfile(source.owner) : null
    } as LeadSummary
}
